/**
 * Dialogs to notify the user of certain interactions.
 * Based on vex Dialogs
 * see: http://github.hubspot.com/vex/api/basic/
 */
var _ = require('lodash')
var Vex = require('vex-js')
var VexDialog = require('vex-dialog')
// import Vex from 'vex-js/src/vex'
// import VexDialog from 'vex-dialog/src/vex.dialog'

Vex.registerPlugin(VexDialog)
Vex.defaultOptions.className = 'vex-theme-dialog'

// var
var Dialog = {
  prepare: (defaultOptions, options) => {
    if (typeof options === 'object') {
      options = Object.assign(defaultOptions, options)
    } else {
      defaultOptions['message'] = options
      var options = defaultOptions
    }
    return options
  },
  alert: (options) => {
    var defaultOptions = {
      showCloseButton: true,
      contentClassName: 'alert'
    }

    options = Dialog.prepare(defaultOptions, options)
    Vex.dialog.alert(defaultOptions)
  },
  notice: (options) => {
    var defaultOptions = {
      showCloseButton: true,
      contentClassName: 'notice'
    }

    options = Dialog.prepare(defaultOptions, options)
    Vex.dialog.alert(defaultOptions)
  },
  confirm: (options) => {
    var defaultOptions = {
      showCloseButton: true,
      contentClassName: 'confirm'
    }

    options = Dialog.prepare(defaultOptions, options)
    Vex.dialog.confirm(defaultOptions)
  },
  prompt: (options) => {
    var defaultOptions = {
      showCloseButton: true,
      contentClassName: 'prompt'
    }

    options = Dialog.prepare(defaultOptions, options)
    Vex.dialog.prompt(defaultOptions)
  }
}

/*
App.dialog.alert('test-1')
App.dialog.notice('test-2')

App.dialog.prompt({
  message: 'What planet did the aliens come from?',
  placeholder: 'Planet name',
  callback: function (value) {
    console.log(value)
  }
})

App.dialog.confirm({
  message: 'Are you absolutely sure you want to destroy the alien planet?',
  callback: function (value) {
    console.log(value)
  }
})
 */

module.exports = Dialog



// WEBPACK FOOTER //
// ./js/common/dialogs.js